import { useEffect } from "react";
import { Alert, Button, Col, Divider, Form, Input, Modal, Row } from "antd";
import { useTranslation } from "react-i18next";

import { useAddTreuhaenderMutation } from "store/masterdata";
import { UpdateTHsParams } from "types/masterdata.types";

interface Props {
  treuhandstelleId: number;
  visible: boolean;
  onClose(): void;
  onSuccess(): void;
}

function AddTHForm({
  treuhandstelleId,
  visible,
  onClose,
  onSuccess,
}: Props): JSX.Element {
  const { t } = useTranslation();
  const [tHsForm] = Form.useForm();

  const [addTH, addTHResult] = useAddTreuhaenderMutation();

  const handleTHFormSubmit = (values: UpdateTHsParams) => {
    addTH({ ...values, treuhandstelleId });
  };

  useEffect(() => {
    if (addTHResult.isSuccess && !addTHResult.data?.hasErrors) {
      onSuccess();
      onClose();
    }
  }, [addTHResult]);

  return (
    <Modal
      footer={null}
      title={t("masterdata.lw_details.add_th")}
      visible={visible}
      onCancel={onClose}
      destroyOnClose
    >
      <Form
        id="ths-form"
        form={tHsForm}
        onFinish={handleTHFormSubmit}
        layout="vertical"
        initialValues={{
          firstname: "",
          lastname: "",
          email: "",
          primaryPhone: "",
        }}
      >
        <p>{t("masterdata.lw_details.add_th_message")}</p>
        {addTHResult.data?.hasErrors && (
          <>
            <Alert
              message={addTHResult.data?.errorDetails.errorMessage}
              type="error"
            />
            <Divider />
          </>
        )}
        <Form.Item
          label={t("masterdata.lw_details.firstname")}
          name="firstname"
          rules={[{ required: true }]}
        >
          <Input />
        </Form.Item>
        <Form.Item
          label={t("masterdata.lw_details.lastname")}
          name="lastname"
          rules={[{ required: true }]}
        >
          <Input />
        </Form.Item>
        <Form.Item
          label={t("masterdata.lw_details.email")}
          name="email"
          rules={[{ required: true, type: "email" }]}
        >
          <Input />
        </Form.Item>
        <Form.Item
          label={t("masterdata.lw_details.phone")}
          name="primaryPhone"
          rules={[{ required: true }]}
        >
          <Input />
        </Form.Item>
        <Row gutter={20}>
          <Col span={12}>
            <Button onClick={onClose} block>
              {t("discard")}
            </Button>
          </Col>
          <Col span={12}>
            <Button
              type="primary"
              htmlType="submit"
              loading={addTHResult.isLoading}
              block
            >
              {t("save_changes")}
            </Button>
          </Col>
        </Row>
      </Form>
    </Modal>
  );
}

export default AddTHForm;
